import React, { useCallback, useRef, useState } from 'react';
import styled from 'styled-components';
import { Placement } from '@popperjs/core';

import IcoEmoji from '@floji-internal/mui-icons/EmojiEmotions';
import * as flomoji from '@floji-internal/noto-emoji';

import { IconButton } from "--components/buttons/iconButton";
import { PopperSurface } from '--floponents-web/molecules/PopperSurface';

import EmojiPicker from './EmojiPicker';
import { Emoji } from "--components/emoji";
import { EmojiBlock } from '--client/../static_types/slate/Shared';

const EmojiPickerPopperSurface = styled(PopperSurface)`
    height: 400px;
    margin: 0;
    overflow: hidden;
    padding: 0;
    width: 312px;
`;

const EmojiPickerIconButton = styled(IconButton).attrs(() => ({
    color: "greyInverted",
    size: "small"
}))`
    flex-shrink: 0;
`;


export interface EmojiPickerButtonProps {
    onSelected: (emoji: EmojiBlock) => void;
    placement?: Placement;
    emojiIcon?: flomoji.tEmoji;
    className?: string;
}



export const EmojiPickerButton = (props: EmojiPickerButtonProps) => {
    const { onSelected } = props;

    /** Reference element for popper position. */
    const buttonElement = useRef<HTMLButtonElement>(null);

    /** Whether emoji picker is currently open. */
    const [isPickerOpen, setIsPickerOpen] = useState(false);
    const handlePopperClosed = useCallback(() => {
        setIsPickerOpen(false);
    }, []);

    const handleButtonClicked = useCallback(() => {
        setIsPickerOpen(isOpen => !isOpen);
    }, []);
    const handleEmojiPicked = useCallback((emoji: flomoji.tEmoji) => {
        setIsPickerOpen(false);

        onSelected({
            type: "emoji",
            shortcut: emoji.shortcut,
            children: [{
                text: emoji.emoji
            }]
        });
    }, [onSelected]);

    return (
        <>
            <EmojiPickerIconButton
                className={props.className}
                ref={buttonElement}
                onClick={handleButtonClicked}
                icon={props.emojiIcon
                    ? <Emoji emoji={props.emojiIcon} />
                    : <IcoEmoji />}
            />

            <EmojiPickerPopperSurface
                triggerRef={buttonElement}
                placement={props.placement}
                containerRef={document.body}
                open={isPickerOpen}
                onClose={handlePopperClosed}
            >
                {isPickerOpen && (
                    <EmojiPicker
                        width={312}
                        height={400}
                        onEmojiPicked={handleEmojiPicked}
                    />
                )}
            </EmojiPickerPopperSurface>
        </>
    );
};
